import { Add, DeleteOutline, SwapHoriz, Storage, Language } from "@material-ui/icons";
import React from "react";
import styled, { keyframes } from "styled-components";
import TabGruposItens from "./TabGruposItens";

function TabMapeamentoIFS({ values, setFieldValue, aplicacaoId }) {
  // ── Estoque Requisição helpers ──
  const estoques = values.estoque_mapping || [];
  const addEstoque = () => setFieldValue("estoque_mapping", [...estoques, { de: "", para: "" }]);
  const removeEstoque = (i) => setFieldValue("estoque_mapping", estoques.filter((_, idx) => idx !== i));
  const updateEstoque = (i, field, val) =>
    setFieldValue("estoque_mapping", estoques.map((r, idx) => idx === i ? { ...r, [field]: val } : r));

  // ── Site helpers ──
  const sites = values.site_mapping || [];
  const addSite = () => setFieldValue("site_mapping", [...sites, { de: "", para: "" }]);
  const removeSite = (i) => setFieldValue("site_mapping", sites.filter((_, idx) => idx !== i));
  const updateSite = (i, field, val) =>
    setFieldValue("site_mapping", sites.map((r, idx) => idx === i ? { ...r, [field]: val } : r));

  return (
    <ModernFormContainer>

      {/* ── Mapeamento de Estoque ── */}
      <SectionCard>
        <SectionHeader>
          <SectionIcon color="#e74c3c"><Storage /></SectionIcon>
          <SectionTitle>Mapeamento de Estoque</SectionTitle>
        </SectionHeader>

        {/* Requisição */}
        <SubSectionLabel>
          <SubBadge color="#3498db">Requisição</SubBadge>
          Mapeamento para Requisição
        </SubSectionLabel>
        <MappingDesc>Configure de qual depósito (DE) as mercadorias serão transferidas e para qual (PARA) nas requisições.</MappingDesc>
        <MappingTable>
          <thead>
            <tr>
              <Th>Estoque DE</Th>
              <Th>Estoque PARA</Th>
              <Th style={{ width: 48 }} />
            </tr>
          </thead>
          <tbody>
            {estoques.length === 0 && (
              <tr><EmptyCell colSpan={3}>Nenhum mapeamento configurado</EmptyCell></tr>
            )}
            {estoques.map((row, i) => (
              <tr key={i}>
                <Td><MappingInput value={row.de} onChange={(e) => updateEstoque(i, "de", e.target.value)} placeholder="Ex: 02" /></Td>
                <Td><MappingInput value={row.para} onChange={(e) => updateEstoque(i, "para", e.target.value)} placeholder="Ex: 05" /></Td>
                <Td><RemoveBtn type="button" onClick={() => removeEstoque(i)}><DeleteOutline style={{ fontSize: 18 }} /></RemoveBtn></Td>
              </tr>
            ))}
          </tbody>
        </MappingTable>
        <AddBtn type="button" onClick={addEstoque}>
          <Add style={{ fontSize: 18, marginRight: 6 }} />Adicionar linha
        </AddBtn>
      </SectionCard>

      {/* ── Mapeamento de Sites ── */}
      <SectionCard>
        <SectionHeader>
          <SectionIcon color="#9b59b6"><Language /></SectionIcon>
          <SectionTitle>Mapeamento de Sites (BPLId)</SectionTitle>
        </SectionHeader>
        <MappingDesc style={{ marginBottom: 12 }}>Configure o BPLId de origem (DE) da filial no IFS e o BPLId de destino (PARA) no SAP B1.</MappingDesc>
        <MappingTable>
          <thead>
            <tr>
              <Th>BPLId DE (IFS)</Th>
              <Th>BPLId PARA (SAP)</Th>
              <Th style={{ width: 48 }} />
            </tr>
          </thead>
          <tbody>
            {sites.length === 0 && (
              <tr><EmptyCell colSpan={3}>Nenhum site configurado</EmptyCell></tr>
            )}
            {sites.map((row, i) => (
              <tr key={i}>
                <Td><MappingInput value={row.de} onChange={(e) => updateSite(i, "de", e.target.value)} placeholder="Ex: SITE_SP" /></Td>
                <Td><MappingInput value={row.para} onChange={(e) => updateSite(i, "para", e.target.value)} placeholder="Ex: 1" type="number" min="1" /></Td>
                <Td><RemoveBtn type="button" onClick={() => removeSite(i)}><DeleteOutline style={{ fontSize: 18 }} /></RemoveBtn></Td>
              </tr>
            ))}
          </tbody>
        </MappingTable>
        <AddBtnRow>
          <AddBtn type="button" onClick={addSite}>
            <Add style={{ fontSize: 18, marginRight: 6 }} />Adicionar site
          </AddBtn>
          {sites.length > 0 && (
            <MappingSummary>{sites.length} site{sites.length > 1 ? "s" : ""} configurado{sites.length > 1 ? "s" : ""}</MappingSummary>
          )}
        </AddBtnRow>
      </SectionCard>

      {/* ── Grupos de Itens ── */}
      <SectionCard>
        <SectionHeader>
          <SectionIcon color="#27ae60"><SwapHoriz /></SectionIcon>
          <SectionTitle>Grupos de Itens</SectionTitle>
        </SectionHeader>
        <TabGruposItens aplicacaoId={aplicacaoId} />
      </SectionCard>

    </ModernFormContainer>
  );
}

export default TabMapeamentoIFS;

// ── Animações ──
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const ModernFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: 'Mulish', sans-serif;
`;

const SectionCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  border: 1px solid #e8e8e8;
  animation: ${fadeIn} 0.5s ease;
  overflow: hidden;
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
`;

const SectionIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => `${props.color || '#ff6b35'}15`};
  color: ${props => props.color || '#ff6b35'};
  margin-right: 12px;
  svg { font-size: 22px; }
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  font-family: 'Mulish', sans-serif;
`;

const SubSectionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 6px;
  font-family: 'Mulish', sans-serif;
`;

const SubBadge = styled.span`
  font-size: 11px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 20px;
  background: ${props => `${props.color}18`};
  color: ${props => props.color};
  border: 1px solid ${props => `${props.color}40`};
  font-family: 'Mulish', sans-serif;
`;

const MappingDesc = styled.p`
  font-size: 13px;
  color: #7f8c8d;
  margin: 0 0 12px 0;
  font-family: 'Mulish', sans-serif;
`;

const MappingTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Mulish', sans-serif;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;
`;

const Th = styled.th`
  text-align: left;
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
`;

const Td = styled.td`
  padding: 8px 12px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
  &:last-child { text-align: center; }
`;

const EmptyCell = styled.td`
  padding: 24px 12px;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
  font-family: 'Mulish', sans-serif;
  background: #fafafa;
`;

const MappingInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  font-family: 'Mulish', sans-serif;
  color: #2c3e50;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s;
  &:focus { border-color: #ff6b35; }
  &[type="number"] {
    -moz-appearance: textfield;
    &::-webkit-outer-spin-button, &::-webkit-inner-spin-button { -webkit-appearance: none; }
  }
`;

const RemoveBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #e74c3c;
  padding: 4px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  &:hover { background: rgba(231,76,60,0.1); }
`;

const AddBtnRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const AddBtn = styled.button`
  display: flex;
  align-items: center;
  width: fit-content;
  background: none;
  border: 1.5px dashed #cbd5e1;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  font-family: 'Mulish', sans-serif;
  transition: all 0.2s;
  &:hover { border-color: #ff6b35; color: #ff6b35; background: rgba(255,107,53,0.04); }
`;

const MappingSummary = styled.span`
  font-size: 12px;
  color: #94a3b8;
  font-family: 'Mulish', sans-serif;
`;
